module.exports = __webpack_public_path__ + "img/home-10.595b3278.png";